var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"appear":"","duration":_vm.transitionTime,"name":"custom-classes-transition","mode":"out-in","enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[_c('router-view',{attrs:{"cached-now":_vm.cachedNow,"cached-now-date":_vm.cachedNowDate,"cached-now-date-string":_vm.cachedNowDateString}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }